import { render, staticRenderFns } from "./tenant-dash.vue?vue&type=template&id=5a90549c&scoped=true&"
import script from "./tenant-dash.vue?vue&type=script&lang=js&"
export * from "./tenant-dash.vue?vue&type=script&lang=js&"
import style0 from "./tenant-dash.vue?vue&type=style&index=0&id=5a90549c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90549c",
  null
  
)

export default component.exports